import { render, staticRenderFns } from "./myRead.vue?vue&type=template&id=577df44e&scoped=true&"
import script from "./myRead.vue?vue&type=script&lang=js&"
export * from "./myRead.vue?vue&type=script&lang=js&"
import style0 from "./myRead.vue?vue&type=style&index=0&id=577df44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577df44e",
  null
  
)

export default component.exports